import { Injectable } from '@angular/core';
import { Checkin } from 'src/app/models/checkin';

import { ApiService, GlobalVar } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class CheckinService {

  constructor(
    public globalvar: GlobalVar,
    public apiService: ApiService,
  ) { }

  post(body) {
    body.user_id = this.globalvar._user.id;
    return this.apiService.post(this.globalvar._createCheckin, body);
  }

  put(body) {
    body.user_id = this.globalvar._user.id;
    return this.apiService.post(`${this.globalvar._putCheckin}/${body.id}`, body);
  }

  get() {

  }

  getAll() {
    return this.apiService.get(`${this.globalvar._getCheckins}/${this.globalvar._user.id}`);
  }

}
